import { Guid, SerializableObject } from '../../common-react/core';

/**
 * DTO Object for representing generic Addresses
 *
 * @see City
 */
export class Address extends SerializableObject {
  public id: Guid;

  // First part of street address
  public street1: string;

  // Continuation of street address
  public street2?: string;

  // The city the address is located in
  public city: string;

  // The zipcode the address is located in
  public postalCode: string;

  // The country the address is located in
  public country: string;
}
